'use strict'

import { Events } from '@ui/Search/Form/Fields/Autocomplete/component'
import elementPropertiesManager from 'assets/core/js/module/elementPropertiesManager'
import common from 'assets/themes/campings/js/page/common/index'

import type { Calendar as SearchCalendarType } from '@ui/Search/Calendar/component'

export default function (): void {
  const calendar = elementPropertiesManager.getProperty<SearchCalendarType>(
    document.getElementById('search_offers_checkInDate') as HTMLInputElement,
    'calendar'
  )
  const autocompleteEl = document.getElementById('search_offers_autocomplete_autocomplete-container')

  if (autocompleteEl) {
    autocompleteEl.addEventListener(Events.AUTOCOMPLETE_ITEM_SELECTED, () => {
      if (!common.isMobile()) {
        calendar?.open()
      }
    })
  }
}
